import type {
  NumerologyRequest,
  NumberProfile,
  NumerologyResponse,
  NumberResult,
} from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type { NumerologyRequest, NumberProfile, NumerologyResponse };
export type { NumberResult } from "@ishvaram/api-client";

export async function calculateNumerology(data: NumerologyRequest): Promise<NumerologyResponse> {
  return apiRequest<NumerologyResponse>("/numerology", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

/** Chaldean name number from a name alone (no birth date). Hand-typed until the
 *  api-client OpenAPI types are regenerated (see CLAUDE.md api-client note). */
export interface NameNumberResponse {
  name: string;
  name_number: NumberResult;
}

export async function calculateNameNumber(name: string): Promise<NameNumberResponse> {
  return apiRequest<NameNumberResponse>("/numerology/name", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ name }),
  });
}
